<script setup>
import { ref, watch } from 'vue'
import { RouterLink, useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
const authStore = useAuthStore()
const route = useRoute()

const pages = ref([
  {
    label: 'דף הבית',
    icon: 'pi pi-home',
    isActive: true,
    path: '/'
  },
  {
    label: 'לקוחות',
    path: '/customers',
    icon: 'pi pi-user'
  },
  {
    label: 'עבודות',
    path: '/jobs',
    icon: 'pi pi-briefcase'
  },
  {
    label: 'תבניות משימה',
    path: '/jobTemplates',
    icon: 'pi pi-briefcase'
  },
  // {
  //   label: 'ביקורים',
  //   path: '/visits',
  //   icon: 'pi pi-eye'
  // }
  {
    label: 'תשלומים',
    path: '/payments',
    icon: 'pi pi-money-bill'
  },
  {
    label: 'פריטי מלאי',
    path: '/inventoryItemSimples',
    icon: 'pi pi-box'
  },
  {
    label: 'תנועות מלאי',
    path: '/inventoryMovements',
    icon: 'pi pi-arrow-right-arrow-left'
  },
  {
    label: 'יומן',
    path: '/daily-plan',
    icon: 'pi pi-calendar'
  },
  {
    label: 'הצעות מחיר',
    path: '/quotes',
    icon: 'pi pi-file'
  },
  {
    label: 'ניהול אזורים',
    path: '/areas',
    icon: 'pi pi-map'
  },
  {
    label: 'ניהול קטגוריות עבודה',
    path: '/jobCategories',
    icon: 'pi pi-tags'
  }
])

const profileMenu = ref()
const profileItem = ref([
  {
    label: 'התנתקות',
    icon: 'pi pi-sign-out',
    command: authStore.logout
  }
])

const drawerVisible = ref(true)

watch(
  () => route.path,
  (newPath) => {
    pages.value.forEach((page) => {
      page.isActive = page.path === newPath
    })
  }
)
</script>

<template>
  <Menubar :model="pages" class="lg:hidden!">
    <template #start>
      <div class="flex items-center gap-2">
        <router-link to="/"><img alt="logo" src="/logo.svg" class="h-9" /></router-link>
        <Button asChild v-slot="slotProps" text size="large">
          <RouterLink to="/daily-plan" :class="slotProps.class"
            ><i class="pi pi-calendar"></i
          ></RouterLink>
          <!-- <RouterLink to="/calendar" :class="slotProps.class"
            ><i class="pi pi-calendar text-xl!"></i
          ></RouterLink> -->
        </Button>
      </div>
    </template>

    <template #item="{ item, props }">
      <router-link v-if="item.path" v-slot="{ href, navigate }" :to="item.path" custom>
        <a v-ripple :href="href" v-bind="props.action" @click="navigate">
          <span :class="item.icon" />
          <span>{{ item.label }}</span>
        </a>
      </router-link>
    </template>

    <template #end>
      <div class="flex items-center gap-2">
        <Button
          :label="authStore.user.name"
          icon="pi pi-user"
          @click="(e) => profileMenu.toggle(e)"
          text
          aria-haspopup="true"
          aria-controls="overlay_menu"
        />
        <Menu ref="profileMenu" id="overlay_menu" :model="profileItem" :popup="true" />
      </div>
    </template>
  </Menubar>

  <div class="bg-surface-0 border-surface-200 hidden h-full w-[20rem] flex-col pr-3 lg:flex">
    <div class="flex items-center justify-between p-5">
      <RouterLink to="/" class="flex items-center gap-2">
        <img alt="logo" src="/logo.svg" class="h-6 sm:h-9" />
        <div class="text-lg font-bold">מקצוען בקליק</div>
      </RouterLink>
    </div>

    <Menu :model="pages" class="h-full overflow-y-auto rounded-none! border-none! p-5">
      <template #item="{ item, props }">
        <div :style="{ background: item.isActive ? '#f1f5f9' : '', radius: '4px' }">
          <router-link v-if="item.path" v-slot="{ href, navigate }" :to="item.path" custom>
            <a v-ripple :href="href" v-bind="props.action" @click="navigate">
              <span :class="item.icon" />
              <span class="ml-2">{{ item.label }}</span>
            </a>
          </router-link>
        </div>
      </template>
    </Menu>

    <div class="flex items-center justify-center p-4">
      <Button
        icon="pi pi-user"
        :label="authStore.user.name"
        text
        class="p-button-rounded p-button-text"
        @click="(e) => profileMenu.toggle(e)"
      />
      <Menu ref="profileMenu" id="overlay_menu" :model="profileItem" :popup="true" />
    </div>
  </div>
</template>
